import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={21.115}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 680000 558660"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#000}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974592739584">
        <path d="M292726 447910h94542v81370h-94542z" className="fill" />
        <path
          d="M193399 520913h293197v37748H193399zM641820 476730H38170C17120 476730 0 459600 0 438550V38170C0 17120 17120 0 38170 0h603650c21050 0 38180 17120 38180 38170v400380c-10 21050-17130 38180-38180 38180zM38170 27070c-6120 0-11100 4980-11100 11100v400380c0 6120 4980 11100 11100 11100h603650c6130 0 11110-4980 11110-11100V38170c0-6120-4980-11100-11110-11100H38170z"
          className="fill"
        />
        <path
          d="M13530 372900v68160c0 13610 11040 24630 24640 24630h603650c13610 0 24640-11020 24640-24630v-68160H13530zm326470 74270c-24760 0-24760-38400 0-38400s24760 38400 0 38400z"
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
